import { shortDate } from '@/pages/reports/non-ats-reports/shared/utils/date-group';
import dayjs from 'dayjs';

export const getCompareTime = (timeFrame) => {
  const { from, to } = timeFrame;
  if (!to) {
    const noOfDays = shortDate[from];
    const toDate = dayjs().subtract(noOfDays + 1, 'day');
    const fromDate = dayjs(toDate).subtract(noOfDays, 'day');
    const formattedCompareFrom = fromDate.format('YYYY-MM-DD');
    const formattedCompareTo = toDate.format('YYYY-MM-DD');
    return { from: formattedCompareFrom, to: formattedCompareTo };
  }
  const diff = dayjs(to).diff(from, 'day');
  const toDate = dayjs(from).subtract(1, 'day');
  const fromDate = dayjs(toDate).subtract(diff, 'day');
  const formattedCompareFrom = fromDate.format('YYYY-MM-DD');
  const formattedCompareTo = toDate.format('YYYY-MM-DD');
  return { from: formattedCompareFrom, to: formattedCompareTo };
};

export const getParams = ({
  timeFrame = {},
  group = {},
  filters = {},
  drilldown = {},
  compare = false,
}) => {
  try {
    const params = {
      filter_by: {
        date: {
          from: timeFrame?.from,
        },
        ...filters,
      },
      date_group: timeFrame?.date_group,
    };

    if (drilldown?.metric) {
      params['drilldown'] = drilldown;
    }

    if (compare) {
      const { from, to } = getCompareTime(timeFrame);
      params['compare'] = {
        date: { from, to },
      };
    }

    if (timeFrame?.to) {
      params['filter_by']['date']['to'] = timeFrame?.to;
    }
    if (group?.group_by_1) {
      params['group_by_1'] = group?.group_by_1?.id;
    }
    if (group?.group_by_2) {
      params['group_by_2'] = group?.group_by_2?.id;
    }

    return params;
  } catch (error) {
    console.error(error);
    return {};
  }
};
